import { FC, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';

import { PageSpinner } from '@app/components';
import { useAppContext } from '@app/contexts';
import { queryKeys, useQueryParams } from '@app/hooks';
import { generateRouteParams } from '@app/utils';
import { Route, ssoRedirectRouteKey } from '@app/constants';

export const SSOPage: FC = () => {
  const { ssoToken } = useQueryParams();
  const { authenticateToken } = useAppContext();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  useEffect(() => {
    if (ssoToken) {
      authenticateToken(
        ssoToken as string,
        sessionStorage.getItem(ssoRedirectRouteKey) ?? ''
      );

      sessionStorage.removeItem(ssoRedirectRouteKey);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    return queryClient.getQueryCache().subscribe(({ query }) => {
      const queryState = query.state;

      if (
        query.queryKey[0] === queryKeys.validateUser &&
        queryState.status === 'error'
      ) {
        const queryResponse = queryState?.error?.response;

        navigate(
          generateRouteParams({
            pathname: Route.login,
            query: {
              errorCode: queryResponse.status,
              errorMessage: `${queryResponse.data}`,
            },
          })
        );
      }
    });
  }, [navigate, queryClient]);

  return <PageSpinner />;
};
